<template>
  <div>
    <div class="card" v-if="isCard">
      <header class="header-card">
        <p>{{ $t('catalogue.marques') }}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-9">
            <b-field :label="$t('centreCommercialEmplacement.enseigne')">
              <b-autocomplete
                v-model="input"
                :data="autocompleteEnseignesList"
                :open-on-focus="false"
                field="label"
                :loading="isFetching"
                :placeholder="$t('centreCommercialEmplacement.creation')"
                @select="item => selectEnseigne(item)"
                @input="getAsyncEnseignesData"
              >
                <template slot="header">
                  <a @click="inProgress()">
                    <span>{{$t('centreCommercialEmplacement.creation')}}</span>
                  </a>
                </template>
                <template slot="empty">
                  <div v-if="!isFetching">{{$t('general.autocomplete.noRslt')}}</div>
                  <div v-else>{{$t('general.autocomplete.search')}}</div>
                </template>
              </b-autocomplete>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('centreCommercialEmplacement.enseignePrincipale')">
              <b-select
                :placeholder="$t('centreCommercialEmplacement.aucuneEnseigne')"
                v-model="enseignePrincipaleClef"
                @input="modifEnseignePrincipale"
                expanded>
                <option value>{{ $t('centreCommercialEmplacement.aucuneEnseigne') }}</option>
                <option
                  v-for="enseigne in getEnseigneSelectedSort"
                  :key="enseigne.clef"
                  :value="enseigne.clef">
                  {{enseigne.marque}}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <ul class="columns is-12 is-multiline is-fullheight">
          <li
            v-for="(element, index) in entiteCommerciale.enseignesMarques"
            :key="index"
            class="column is-3-fullhd is-4-tablet"
          >
            <div class="enseigne columns is-marginless is-full">
              <div  class="column is-narrow  is-paddingless"
                v-if="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo">
                <img
                  :src="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo"
                  class="image is-96x96"
                />
              </div>
              <div  class="column is-narrow  is-paddingless"
                v-else>
                <img src="/static/img/gabed/emplacement/image_defaut.png" class="image is-96x96" />
              </div>
              <div class="columns column is-vcentered is-marginless
                is-paddingless is-multiline  ellipsis">
                <p class="column is-12 has-text-weight-bold">
                    {{element.nom ? element.nom : element.marque}}
                </p>
                <span class="is-size-7 column is-12 pdt-0">
                  {{element.libelleTypeMarque ? element.libelleTypeMarque : element.type}}
                </span>
              </div>
              <div class="column is-narrow" v-if="element.idExterne">
                <span class="pastille-verte">
                </span>
              </div>
              <div class="column is-narrow pdt-20px mgt-5px">
                <b-dropdown position="is-bottom-left" aria-role="list" class="is-pulled-right">
                  <a slot="trigger">
                    <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                  </a>
                  <b-dropdown-item @click="inProgress()">
                    <p class="is-default is-size-6">
                      {{ $t('general.button.edit')}}
                    </p>
                  </b-dropdown-item>
                  <b-dropdown-item @click="inProgress()">
                    <p class="is-default is-size-6">
                      {{ $t('general.button.delete')}}
                    </p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div class="columns is-12">
        <div class="column is-9">
          <b-field :label="$t('centreCommercialEmplacement.enseigne')">
            <b-autocomplete
              v-model="input"
              :data="autocompleteEnseignesList"
              :open-on-focus="false"
              field="label"
              :loading="isFetching"
              :placeholder="$t('centreCommercialEmplacement.creation')"
              @select="item => selectEnseigne(item)"
              @input="getAsyncEnseignesData"
            >
              <template slot="empty">
                <div v-if="!isFetching">{{$t('detail.article.noResult')}}</div>
                <div v-else>{{$t('detail.article.search')}}</div>
              </template>
              <template slot="header">
                <a @click="inProgress()">
                  <span>{{$t('centreCommercialEmplacement.creation')}}</span>
                </a>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('centreCommercialEmplacement.enseignePrincipale')">
            <b-select
              :placeholder="$t('centreCommercialEmplacement.aucuneEnseigne')"
              v-model="enseignePrincipaleClef"
              @input="modifEnseignePrincipale"
              expanded
            >
              <option value>{{ $t('centreCommercialEmplacement.aucuneEnseigne') }}</option>
              <option v-for="enseigne in getEnseigneSelectedSort"
                :key="enseigne.clef"
                :value="enseigne.clef">
                {{enseigne.marque}}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <ul class="columns is-12 is-multiline is-fullheight">
        <li
          v-for="(element, index) in entiteCommerciale.enseignesMarques"
          :key="index"
          class="column is-4-fullhd is-6-tablet">
          <div class="enseigne columns is-marginless is-full">
            <div class="column is-narrow is-paddingless"
              v-if="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo">
              <img
                :src="element.urlLogoMarque ? element.urlLogoMarque : element.urlLogo"
                class="image is-96x96"
              />
            </div>
            <div class="column is-narrow is-paddingless" v-else>
              <img src="/static/img/gabed/emplacement/image_defaut.png" class="image is-96x96" />
            </div>
            <div class="columns column is-vcentered is-marginless
              is-paddingless is-multiline ellipsis">
              <p class="column is-12 has-text-weight-bold">
                {{element.nom ? element.nom : element.marque}}
              </p>
              <span class="is-size-7 column is-12 pdt-0">
                {{element.libelleTypeMarque ? element.libelleTypeMarque : element.type}}
              </span>
            </div>
            <div class="column is-narrow" v-if="element.idExterne">
              <span class="mgl-10px pastille-verte"></span>
            </div>
            <div class="column is-narrow pdt-20px mgt-5px">
              <b-dropdown position="is-bottom-left" aria-role="list" class="is-pulled-right">
                <a slot="trigger" class="is-pulled-right">
                  <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                </a>
                <b-dropdown-item @click="inProgress()">
                  <p class="is-default is-size-6">
                    {{ $t('general.button.edit')}}
                  </p>
                </b-dropdown-item>
                <b-dropdown-item @click="inProgress()">
                  <p class="is-default is-size-6">
                    {{ $t('general.button.delete')}}
                  </p>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import getMarques from '@/api/gabed/dataplateforme/index';
import inProgress from '@/services/general/inProgress';
import genererArrayEnseignes from '@/services/gabed/emplacement/centreCommercial/genererArrayEnseignes';
import genererGuid from '@/services/general/genererGuid';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'EditEnseignes',
  data() {
    return {
      autocompleteInput: '',
      isFetching: false,
      autocompleteEnseignesList: [],
      input: '',
      enseigneSelected: [],
      enseignePrincipaleClef: null,
    };
  },
  computed: {
    getEnseigneSelectedSort() {
      const enseignesMarques = cloneDeep(
        this.entiteCommerciale.enseignesMarques,
      );
      return enseignesMarques.sort((a, b) => {
        const enseigneA = a.marque.toLowerCase();
        const enseigneB = b.marque.toLowerCase();
        return enseigneA.localeCompare(enseigneB);
      });
    },
  },
  props: {
    entiteCommerciale: {
      type: Object,
      required: true,
    },
    isCard: {
      type: Boolean,
      required: false,
    },
  },
  created() {
    this.genereClefEnseignesEdition();
    const enseignePrincipale = this.entiteCommerciale.enseignesMarques.find(
      el => {
        return el.enseignePrincipale === true;
      },
    );
    if (enseignePrincipale) {
      this.enseignePrincipaleClef = enseignePrincipale.clef;
    }
  },
  methods: {
    getAsyncEnseignesData: debounce(async function loadData() {
      this.isFetching = true;
      this.autocompleteEnseignesList = [];
      if (!this.input) return;
      try {
        const response = (await getMarques({
          nom: this.input,
        })).data;
        const arrayEnseignes = genererArrayEnseignes(response);
        this.autocompleteEnseignesList = arrayEnseignes.filter(element => {
          return !this.entiteCommerciale.enseignesMarques.find(el => {
            return el.idExterne === element.idExterne;
          });
        });
        this.autocompleteEnseignesList.forEach(item => {
          item.label = item.marque;
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw (e);
      }
    }, 500),
    selectEnseigne(enseigne) {
      if (enseigne) {
        const loadingComponent = this.$buefy.loading.open();
        try {
          enseigne.clef = genererGuid();
          this.entiteCommerciale.enseignesMarques.unshift(enseigne);
          this.autocompleteEnseignesList = this.autocompleteEnseignesList.filter(
            el => {
              if (el.id !== enseigne.id) {
                return el;
              }
              return null;
            },
          );
          loadingComponent.close();
        } catch (e) {
          loadingComponent.close();
          throw e;
        }
      }
    },
    genereClefEnseignesEdition() {
      this.entiteCommerciale.enseignesMarques.forEach(el => {
        if (el.id) {
          el.clef = el.id;
        }
      });
    },
    modifEnseignePrincipale() {
      this.entiteCommerciale.enseignesMarques.forEach(el => {
        if (el.enseignePrincipale === true) {
          el.enseignePrincipale = false;
        }
      });
      if (!this.enseignePrincipaleClef) {
        return;
      }
      const enseignePrincipale = this.entiteCommerciale.enseignesMarques.find(
        el => {
          return el.clef === this.enseignePrincipaleClef;
        },
      );
      enseignePrincipale.enseignePrincipale = true;
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
};
</script>
